export default __webpack_public_path__ + "static/media/vaccine-active.e7bc3f0c.svg";